import type {
  IPastContextPrechart,
  IPastContextPrechartItem,
} from "../../../core/ports/driver/VisitNotesService";

export const buildPastContextPrechartUrl = (
  routeTemplate: string,
  clinicId: number,
  patientId: number,
  noteId: number
): string =>
  routeTemplate
    .replace("{clinic_id}", clinicId.toString())
    .replace("{patient_id}", patientId.toString())
    .replace("{note_id}", noteId.toString());

export const normalizePastContextPrechart = (
  value: unknown
): IPastContextPrechart | null => {
  if (!value || typeof value !== "object") return null;
  const candidate = value as Partial<IPastContextPrechart>;
  if (
    candidate.status !== "loading" &&
    candidate.status !== "completed" &&
    candidate.status !== "failed"
  ) {
    return null;
  }

  return {
    status: candidate.status,
    request_id:
      typeof candidate.request_id === "string" ? candidate.request_id : "",
    lookback_days:
      typeof candidate.lookback_days === "number"
        ? candidate.lookback_days
        : 60,
    generated_at:
      typeof candidate.generated_at === "string"
        ? candidate.generated_at
        : null,
    error: typeof candidate.error === "string" ? candidate.error : null,
    items: Array.isArray(candidate.items)
      ? candidate.items.filter(
          (item): item is IPastContextPrechartItem =>
            item !== null &&
            typeof item === "object" &&
            typeof item.note_id === "number"
        )
      : [],
  };
};

export const parsePastContextPrechartResponse = (
  response: unknown,
  fallbackMessage: string
): IPastContextPrechart => {
  const envelope =
    response && typeof response === "object"
      ? (response as Record<string, any>)
      : {};
  const data = envelope.data ?? envelope;
  const context =
    normalizePastContextPrechart(data) ??
    normalizePastContextPrechart(data?.past_context_prechart);

  if (context) return context;

  const detail = data?.detail;
  const message =
    (typeof detail === "string" ? detail : detail?.message) ||
    data?.message ||
    fallbackMessage;
  throw new Error(message);
};
